import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Link, Preloader, Status } from 'components';
import classNames from 'classnames/bind';
import { isEmpty } from 'ramda';
import { SuccessDisconnectStatus } from '../Statuses';

import styles from './styles.pcss';
import { DisconnectDialogDatePicker } from './DisconnectDialogDatePicker';

const cx = classNames.bind(styles);

export const DisconnectDialog = ({
  params, onCancelClick, onDisconnectClick, requestId, isDisconnecting, onInit, onChangeDate, disconnectionDate,
}) => {
  useEffect(() => onInit?.(), []);

  if (isEmpty(params)) {
    return (
      <Status className={cx('component')}>
        <Preloader className={cx('preloader')} size="48" />
      </Status>
    );
  }

  if (requestId) {
    return <SuccessDisconnectStatus id={requestId} />;
  }

  return (
    <Status className={cx('component')}>
      {params?.futureOperationEnabled && params.shiftDays && (
        <DisconnectDialogDatePicker
          date={disconnectionDate}
          shiftDays={params.shiftDays}
          onChange={onChangeDate}
        />
      )}

      <Button
        className="default"
        onClick={onDisconnectClick}
        disabled={params?.futureOperationEnabled && !disconnectionDate}
        isLoading={isDisconnecting}
      >
        Отключить
      </Button>

      <Link className={cx('cancel')} onClick={onCancelClick}>
        Отменить
      </Link>
    </Status>
  );
};

DisconnectDialog.propTypes = {
  params: PropTypes.shape({
    shiftDays: PropTypes.number,
    isProcessing: PropTypes.bool,
    futureOperationEnabled: PropTypes.bool,
  }),
  disconnectionDate: PropTypes.string,
  requestId: PropTypes.string,
  onChangeDate: PropTypes.func,
  onDisconnectClick: PropTypes.func,
  onInit: PropTypes.func,
  onCancelClick: PropTypes.func,
  isDisconnecting: PropTypes.bool,
};
